// I'm not sure if this is the original place I got this from or not
//https://gist.github.com/steveh80/288a9a8bd4c3de16d799

let viewportUtils = {
  viewports: ['xs', 'sm', 'md', 'lg', 'xl'],
  // returns the active viewport from viewportUtils.viewports array
  viewportSize: function () {
    return window.getComputedStyle(document.body, ':before').content.replace(/"/g, '');
  },
  // why do we need this? Why wouldn't we just check if viewportSize === size? 
  is: function (size) {
    if (this.viewports.indexOf(size) == -1) throw "no valid viewport name given";
    return this.viewportSize() == size;
  },
  isEqualOrGreaterThan: function (size) {
    if (this.viewports.indexOf(size) == -1) throw "no valid viewport name given";
    return this.viewports.indexOf(this.viewportSize()) >= this.viewports.indexOf(size);
  }
  //
  // // Public API
  // return {
  //   is: is,
  //   isEqualOrGreaterThan: isEqualOrGreaterThan
  // }
};

export default viewportUtils;